import { render } from "./PainelMalhas.vue?vue&type=template&id=29a0094f&scoped=true"
import script from "./PainelMalhas.vue?vue&type=script&lang=js"
export * from "./PainelMalhas.vue?vue&type=script&lang=js"

import "./PainelMalhas.vue?vue&type=style&index=0&id=29a0094f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29a0094f"]])

export default __exports__